export enum ReassignmentState {
  Created = 'Created',
  Accepted = 'Accepted',
  Rejected = 'Rejected'
}
